import { useBotId } from '../../../store/flow'
import { prompt } from '../../../lib/bootbox'
import { feedbotToast } from '../../../lib/feedbotToast'
import { nlpChatQueriesApi } from '../nlpChatQueriesApi'
import { useUserRole } from '../../../store/user/hooks/useUserRole'

type Params = { day: string; queryId: string; rating: boolean }

export function useRateQuery() {
  const botId = useBotId()
  const role = useUserRole()
  const [rateQuery, { isLoading, isSuccess }] = nlpChatQueriesApi.useRateNlpChatQueryMutation()

  return {
    statusFlags: { isLoading, isSuccess },
    rateQuery: async ({ day, queryId, rating }: Params) => {
      if (!botId || !queryId) {
        feedbotToast.error({
          title: 'Unexpected error',
          content: `There is something wrong with botId (${botId}) or queryId (${queryId}). 
      This should not be happening. Please contact support.`
        })
      }

      const internalRatingExplanation = !rating
        ? await prompt({
            title: 'Please type in why you left this rating',
            value: ''
          })
        : ''

      if (internalRatingExplanation === null) return
      await rateQuery({
        ...{ botId, queryId },
        ...{ day, rating, internalRatingExplanation },
        role: role === 'admin' ? 'admin' : 'customer'
      })
    }
  }
}
